import { PlotPlanMapping } from "@/sx-layout/hooks/usePlotPlanMappingApi";

/**
 * 既存 UI（Moveable 等）が扱う矩形形状。
 */
export type Area = {
  top: number;
  left: number;
  width: number;
  height: number;
  rotation: number;
};

/**
 * クリップ領域の矩形形状。
 */
export type Clip = {
  top: number;
  left: number;
  width: number;
  height: number;
};

/**
 * PlotPlanMapping から表示矩形（Area）へ変換する。
 * - top/left は表示位置 (y/x)
 * - width/height は clip_w * scale_x / clip_h * scale_y で動的算出
 */
export const toDisplayRect = (m: PlotPlanMapping): Area => ({
  top: m.y,
  left: m.x,
  width: m.clip_w * m.scale_x,
  height: m.clip_h * m.scale_y,
  rotation: m.rotation,
});

/**
 * PlotPlanMapping からクリップ領域（Clip）へ変換する。
 */
export const toClip = (m: PlotPlanMapping): Clip | undefined => {
  if (!m) return undefined;
  return {
    top: m.clip_y,
    left: m.clip_x,
    width: m.clip_w,
    height: m.clip_h,
  };
};
